import withFeatureFlagger from './withEnvVariable';
export default withFeatureFlagger;
